const leadDistributionSortReducer = (
    state = {},
    action: {
      type: "SET_LEAD_DISTRIBUTION_FILTER_SORT";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_LEAD_DISTRIBUTION_FILTER_SORT":
        return { ...action.payload };
  
      default:
        return state;
    }
  };
  
  export default leadDistributionSortReducer;